$(function() {

    /* globals $ */

    'use strict';

    $(document).on('change', 'select.contact-type', function () {

        $.ajax({
            url: '/responsibilities/' + $(this).data('responsibility-id') + '/contact_type',
            type: 'PATCH',
            dataType: 'json',
            data: {
                value: $(this).val()
            }
        });

    });

    $(document).on('change', 'input.do-not-contact', function () {

        $.ajax({
            url: '/responsibilities/' + $(this).data('responsibility-id') + '/do_not_contact',
            type: 'PATCH',
            dataType: 'script',
            data: {
                value: $(this).prop('checked')
            }
        });

    });

    $(document).on('change', 'input.do-not-mail', function () {

        $.ajax({
            url: '/responsibilities/' + $(this).data('responsibility-id') + '/do_not_mail',
            type: 'PATCH',
            dataType: 'script',
            data: {
                value: $(this).prop('checked')
            }
        });

    });

    /* Drag and Drop for contact people */

    var c = {};

    $(document).on('mouseover', 'tr:not(.ui-draggable)', function(){
        $('tr.draggable').draggable({
            axis: 'y',
            containment: 'parent',
            helper: function() {
                $(this).children().each(function() {
                    $(this).width($(this).width());
                });
                return $(this).clone();
            },
            start: function(event, ui) {
                c.tr = this;
                c.helper = ui.helper;
            }
        });
    });


    $(document).on('mouseover', 'tr:not(.ui-droppable)', function(){
        $('tr.droppable').droppable({

            drop: function( event, ui ) {

                $(c.tr).remove();
                $(c.helper).remove();

                var contactId = ui.draggable.data('contact-id'),
                    responsibilityId = $(event.target).data('responsibility-id'),
                    obsoleteResponsibilityId = ui.draggable.data('responsibility-id');

                $.ajax({
                    url: '/responsibilities/' + responsibilityId + '/contact_people',
                    type: 'POST',
                    dataType: 'script',
                    data: {
                        contact_id: contactId,
                        obsolete_responsibility_id: obsoleteResponsibilityId
                    }
                });
            },
            over: function(event, ui) {
                $(this).addClass('drop-allowed');
            },
            out: function(event, ui) {
                $(this).removeClass('drop-allowed');
            }

        });
    });

});